import React from "react";
import Spin from "antd/lib/spin";
// import "./style.scss";

// export const Spinner = () => {
//   return (
//     <div className="main">
//       <div className="spinner">
//         <Spin size="large" />
//       </div>
//     </div>
//   );
// };


export const Spinner = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-black/5 rounded-md p-8">
      <Spin size="large" />
    </div>
  );
};